import React, { memo, useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatDateTimePreOrder, getOrderDate, isDateOverdue } from '../../../../utils/order';
import { getRestaurant } from '../../../../store/selectors';
import { DELIVERY_STRATEGY } from '../../../../utils/enums';
import { TimeInfo } from '../TimeInfoOrderDraft';
import IconButton from '../../IconButton';
import './index.scss';

const INTERVAL_TIMER = 30000;

export const CreationDate = ({ creationDatetime }) => {
	const [orderDate, setOrderDate] = useState(getOrderDate(creationDatetime || ''));

	useEffect(() => {
		setOrderDate(getOrderDate(creationDatetime || ''));
		const interval = setInterval(() => {
			setOrderDate(getOrderDate(creationDatetime || ''));
		}, INTERVAL_TIMER);

		return () => clearInterval(interval);
	}, [creationDatetime]);

	return <div className='CreationDate'>{orderDate}</div>;
};

export const OrderDateDraft = memo(
  ({
    deliveryStrategy,
    creationDatetime,
    deliveryDatetime,
    readinessTime,
    cooking,
    cookingTime,
    isCookingReady,
  }) => {
    const { t } = useTranslation();
    const restaurant = useSelector(getRestaurant);

    const isAlwaysShowCookingTimeSpan =
      restaurant?.configuration?.alwaysShowCookingTimeSpan;

    const getTime = () => {
      if (!cooking) {
        return t('draft.xMinutes', { min: cookingTime || '0' });
      }

      const now = moment();
      const end = moment(readinessTime);

      const minsTillReady = -moment.duration(now.diff(end)).asMinutes();

      const minsTillReadyString = `(${t('draft.xMinutes', {
        min: Math.ceil(minsTillReady)
      })})`;

      return `${moment(readinessTime).format('HH:mm')} ${
        minsTillReady >= 0 && !isAlwaysShowCookingTimeSpan
          ? minsTillReadyString
          : ''
      }`;
    };

    return (
      <div className='orderDateDraft'>
        {(deliveryStrategy === DELIVERY_STRATEGY.asap ||
          !deliveryStrategy) && (
            <CreationDate creationDatetime={creationDatetime} />
        )}

        {deliveryStrategy === DELIVERY_STRATEGY.concreteTime && (
          <span className={'createDate'}>
            <span className={'scheduleLabel'}>
              {t('draft.scheduled')}
            </span>{' '}
            {formatDateTimePreOrder(deliveryDatetime || '')}
          </span>
        )}

        {readinessTime && (
          <>
            {isCookingReady ? (
              <div className={'cookingReadyBlock'}>
                {isAlwaysShowCookingTimeSpan && (
                  <>
                    <span className={'createDate'}> | </span>

                    <IconButton isIcon iconName={'orderStatusCooking'} />

                    <span className={'cookingTimeSpan'}>
                      {t('draft.xMinutes', { min: cookingTime || '0' })}
                    </span>
                  </>
                )}
              </div>
            ) : (
              <>
                <span className={'createDate'}> | </span>

                <TimeInfo
                  isAlwaysShowCookingTimeSpan={
                    isAlwaysShowCookingTimeSpan
                  }
                  isCooking={cooking}
                  cookingTime={cookingTime}
                  icon={() => (
                    <IconButton isIcon iconName={'orderStatusCooking'} />
                  )}
                  value={getTime()}
                  isWarning={
                    cooking
                      ? isDateOverdue(new Date(), readinessTime)
                      : false
                  }
                  warningDescription={t(
                    'draft.cookingOverdue',
                    {
                      date: moment(readinessTime).format('HH:mm')
                    }
                  )}
                />
              </>
            )}
          </>
        )}
      </div>
    );
  }
);